export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
export const SignUpRedesign = 'TEMP-16449-sign-up-flow-redesign-office-sign-up-flow-dental-portal';
export const TnCOffices = 'TEMP-15427-tnc-offices';
export const ShowAchAuthorizationPopup = 'show-ach-authorization-popup';
export const EnablePermSessionRecording = 'ARF-1725-enable-perm-session-recording-dental-portal';
export const EnableSignUpSessionRecording =
  'TEMP-16399-enable-signup-session-recording-dental-portal';
export const EnforcePostAJobFunnelImprovements = 'ARF-1899-post-a-job-funnel-improvements';
export const EnableDailyPayOption = 'ARF-1866-add-daily-pay-option';
export const DashboardPermNewBadge = 'ARF-1799-dashboard-perm-new-badge';
export const ProfessionalHubRedesign = 'TEMP-15781-Dental-New-to-You-Redesign';
export const EnablePermanentJobM2M = 'ARF-1552-enable-perm-m2m-dental-portal';
export const CredentialingV2 = 'TEMP-13770-credentialing-v2';
export const CredentialingV2DNTApi = 'GOTU-2547-credentialing-v2-dnt-api';
export const TurnstileLoginEnabled = 'turnstile-login-enabled';
export const EnforceUpdateInterviewRequest = 'GOTU-609-update-interview-request-dp';
export const HideRequestReportButton = 'TEMP-13338-hide-request-report-button';
export const DomainDecommissioning = 'TEMP-13485-domain-decommissioning';
export const EnforcePermanentJobV2 = 'ARF-626-enforce-permanent-job-v2-dental-portal';
export const ImportJobDescriptionFlow = 'ARF-1900-import-jd-flow';
export const GenerateJobDescription = 'GOTU-2526-generate-job-description';
export const EnforcePromoCode = 'ARF-2092-promo-codes';
export const AutoNavigateActionNeeded = 'GOTU-3821-auto-navigate-action-needed';
export const ShiftRequestRateFriction = 'GOTU-3866-shift-request-rate-friction';
export const AutoConfirmDefaultOn = 'GOTU-4259-autoconfirm-default-on';
export const ReadOfficeDetailFromOrgService = 'GOTU-4961-dental-portal-office-read';
export const SdbEnhancedRate = 'GOTU-972-sdb-enhanced-rate';
export const SortInviteListsByAvailability = 'GOTU-4327-sort-invite-lists-by-availability';
export const SaltclickChatbot = 'GOTU-4448-saltclick-chatbot';
export const BestInDentalV2 = 'GOTU-5623-best-in-dental-web';
export const ShiftDetailsInviteSection = 'GOTU-5384-shift-details-invite-section';
export const LastMinuteAutoConfirm = 'GOTU-5391-last-minute-auto-confirm';
